<template lang="html">
  <div class="container">
    <p class="panel-heading">
      E-mails do Usuário: <strong>{{nameUser}}</strong>
      <router-link class="button is-small is-primary is-pulled-right" :to="{name: 'AppUsersEmailNew'}">
        <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
          Enviar Novo
      </router-link>
      <div class="is-clearfix"></div>
    </p>
    <table class="table">
    <thead>
      <tr>
        <th><abbr title="Position">Codigo</abbr></th>
        <th>ID Email</th>
        <th title="E-mail">Destinatário</th>
        <th title="Status">Assunto</th>
        <th title="Status">Status</th>
        <th title="Status">Data da Envio</th>
        <th title="Status">Data da Entrega</th>
        <th title="Status">Data da Leitura</th>
        <th title="Editar">Info</th>
      </tr>
    </thead>
    <tfoot>
      <tr>
        <th><abbr title="Position">Codigo</abbr></th>
        <th>ID</th>
        <th title="E-mail">Destinatário</th>
        <th title="E-mail">Assunto</th>
        <th title="Status">Status</th>
        <th title="Status">Data da Envio</th>
        <th title="Status">Data da Entrega</th>
        <th title="Status">Data da Leitura</th>
        <th title="Editar">Info</th>
      </tr>
    </tfoot>
    <tbody>
      <tr v-for="email in emailsUser">
        <td>{{email.ema_codigo}}</td>
        <td>{{email.ema_data.id_email}}</td>
        <td>{{email.ema_data.destinatario}}</td>
        <td>{{email.ema_data.assunto}}</td>
        <td>{{email.ema_status.erro || 'Sucesso'}}</td>
        <td>{{formatDate(email.ema_status.status.data_envio)}}</td>
        <td>{{formatDate(email.ema_status.status.data_entrega)}}</td>
        <td>{{formatDate(email.ema_status.status.data_leitura)}}</td>
        <td>
          <a class="button is-success" @click.prevent="getStatus(email.ema_data.id_email)">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-if="loading" class="sk-folding-cube">
    <div class="sk-cube1 sk-cube"></div>
    <div class="sk-cube2 sk-cube"></div>
    <div class="sk-cube4 sk-cube"></div>
    <div class="sk-cube3 sk-cube"></div>
  </div>
</div>
</template>

<script>
import swal from 'sweetalert2'
import moment from 'moment'
import { listEmailsUser, getStatusEmail, getUser } from './users.service'
moment.locale('pt-BR')

export default {
  name: 'AppEmailsList',
  data () {
    return {
      codUser: '',
      nameUser: '',
      tokenUser: '',
      emailsUser: [],
      loading: false
    }
  },
  methods: {
    getAllEmailsUser () {
      this.loading = true
      listEmailsUser(this.codUser)
      .then(response => {
        this.loading = false
        this.emailsUser = response
      })
    },
    getStatus (idEmailBry) {
      getStatusEmail(this.tokenUser, idEmailBry)
      .then(response => {
        const message = response.status
        console.log(message)
        swal({
          title: 'Status:',
          html: `<p><b>Data do Envio:</b> ${this.formatDate(message.data_envio) || 'Não possui'}</p>
          <p><b>Data da Entrega:</b> ${this.formatDate(message.data_entrega) || 'Não possui'}</p>
          <p><b>Data da Visualização:</b> ${this.formatDate(message.data_leitura) || 'Não possui'}</p>`,
          type: 'success',
          showLoaderOnConfirm: true
        })
        .then(() => {
          this.$router.push({ name: 'AppUsersEmailsList' })
        })
      })
    },
    formatDate (date) {
      if (date) {
        return moment(new Date(date)).format('DD/MM/YYYY H:mm:ss')
      }
    }
  },
  mounted () {
    this.codUser = this.$route.params.codUser
    getUser(this.codUser)
    .then(response => {
      this.tokenUser = response.use_data.token
      this.nameUser = response.use_data.nome
      this.getAllEmailsUser()
    })
  }
}
</script>

<style lang="css">
.sk-folding-cube {
  margin: 20px auto;
  width: 40px;
  height: 40px;
  top: 45%;
  left: 45%;
  position: absolute;
  -webkit-transform: rotateZ(45deg);
          transform: rotateZ(45deg);
}

.sk-folding-cube .sk-cube {
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
          transform: scale(1.1);
}
.sk-folding-cube .sk-cube:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #333;
  -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;
          animation: sk-foldCubeAngle 2.4s infinite linear both;
  -webkit-transform-origin: 100% 100%;
      -ms-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
}
.sk-folding-cube .sk-cube2 {
  -webkit-transform: scale(1.1) rotateZ(90deg);
          transform: scale(1.1) rotateZ(90deg);
}
.sk-folding-cube .sk-cube3 {
  -webkit-transform: scale(1.1) rotateZ(180deg);
          transform: scale(1.1) rotateZ(180deg);
}
.sk-folding-cube .sk-cube4 {
  -webkit-transform: scale(1.1) rotateZ(270deg);
          transform: scale(1.1) rotateZ(270deg);
}
.sk-folding-cube .sk-cube2:before {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s;
}
.sk-folding-cube .sk-cube3:before {
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}
.sk-folding-cube .sk-cube4:before {
  -webkit-animation-delay: 0.9s;
          animation-delay: 0.9s;
}
@-webkit-keyframes sk-foldCubeAngle {
  0%, 10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
            transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
            transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
            transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

@keyframes sk-foldCubeAngle {
  0%, 10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
            transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
            transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
            transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// UsersEmailsList.vue?f7f81106